
import BestGallery from './components/BestGallery';

export default {
  i18nComponentKey: 'WidgetReviewsBestGallery.WidgetReviewsBestGalleryPc',
  name: 'WidgetReviewsBestGalleryPc',
  components: { BestGallery }
};
